import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyBu28H4yCeTeHeUsoYmAvjwNR9BNqkBVUU",
    authDomain: "linkedin-e1729.firebaseapp.com",
    projectId: "linkedin-e1729",
    storageBucket: "linkedin-e1729.appspot.com",
    messagingSenderId: "1035649512877",
    appId: "1:1035649512877:web:b70ed956285a713d269d24"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();

export { db, auth };